/**
 * HTML标签转义（  < -----> &lt;）
 */
export function html2Escape(sHtml) {
    return sHtml.replace(/[<>&"]/g, function (c) {
      return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c];
    });
  }
  
  /**
   * HTML标签反转义（  &lt; ----> < ）
   */
  export function escape2Html(str) {
    var arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' };
    return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
      return arrEntities[t];
    });
  }
  
  